import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Subcontent } from '../Subcontent';
import { IconButton } from '../../Button/IconButton';
import DraggableIcon from '../../Icons/DraggableIcon';

const StyledContainer = styled.div`
  margin-bottom: 20px;
  width: 100%;
`;

const StyledDraggableLabelContainer = styled.div`
  display: flex;
  align-items: center;
`;

const renderDrdLabel = (label) => {
  return (
    <StyledDraggableLabelContainer>
      <IconButton
        alt="draggable_icon"
        iconSvg={<DraggableIcon color={'#B0B0B0'} />}
        width={24}
        height={24}
        ml={-0.375}
        mr={0.438}
        mt={0.5}
      />
      <div>{label}</div>
    </StyledDraggableLabelContainer>
  );
};

// Exposing a DOM ref from your Component
// Docs: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/using-inner-ref.md
const ListDraggableItem = ({
  provided,
  snapshot,
  innerRef,
  label,
  sublabel,
  disableDelete,
  onEditClick,
  onDeleteClick,
  editTooltipText,
  deleteTooltipText,
  hideEdit,
  hideDelete,
  isMobile,
}) => (
  <StyledContainer
    {...provided.draggableProps}
    {...provided.dragHandleProps}
    snapshot={snapshot}
    ref={innerRef}
  >
    <Subcontent
      collapsed
      label={renderDrdLabel(label)}
      sublabel={sublabel}
      disableDelete={disableDelete}
      onEditClick={onEditClick}
      onDeleteClick={onDeleteClick}
      editTooltipText={editTooltipText}
      deleteTooltipText={deleteTooltipText}
      hideEdit={hideEdit}
      hideDelete={hideDelete}
      isMobile={isMobile}
    />
  </StyledContainer>
);

export default ListDraggableItem;
